import React, { useState, useEffect } from 'react';
import { useReducedMotion } from '@/hooks/useReducedMotion';

interface TypewriterTextProps {
  text: string;
  speedMs?: number;
  onCompleted?: () => void;
  className?: string;
}

export default function TypewriterText({
  text,
  speedMs = 70,
  onCompleted,
  className = '',
}: TypewriterTextProps) {
  const [displayedText, setDisplayedText] = useState('');
  const prefersReducedMotion = useReducedMotion();

  useEffect(() => {
    // If reduced motion is preferred, show full text immediately
    if (prefersReducedMotion) {
      setDisplayedText(text);
      if (onCompleted) {
        onCompleted();
      }
      return;
    }

    // Reset displayed text when text prop changes
    setDisplayedText('');
    let currentIndex = 0;

    const interval = setInterval(() => {
      if (currentIndex < text.length) {
        currentIndex++;
        setDisplayedText(text.slice(0, currentIndex));
      } else {
        clearInterval(interval);
        if (onCompleted) {
          onCompleted();
        }
      }
    }, speedMs);

    return () => {
      clearInterval(interval);
    };
  }, [text, speedMs, onCompleted, prefersReducedMotion]);

  return <span className={className}>{displayedText}</span>;
}

